import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BuildChildren from 'utils/BuildChildren';
import classes from './CardTextC.module.scss';

const CardTextC = (props) => {
  const {
    heading,
    subHeading,
    contentMarkup,
    longContentMarkup,
    buttons = [],
    color,
  } = props;

  const borderColor = `border-${color}`;

  // A separate element for topBorder is needed because borders are bevelled and this needs to span entire top border
  return (
    <div className={classNames(classes.container, borderColor)}>
      <div className={classes.wrapper}>
        {heading &&
          <h3
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
        {subHeading &&
          <h4
            className={classes.subHeading}
            dangerouslySetInnerHTML={{ __html: subHeading }}
          />}
        {contentMarkup &&
          <div
            className={classes.contentMarkup}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
        {longContentMarkup &&
          <div
            className={classes.longContentMarkup}
            dangerouslySetInnerHTML={{ __html: longContentMarkup }}
          />}
        {buttons.length > 0 &&
        <div className={classes.itemsContainer}>
          {buttons.map((item, i) => (
            <div className={classes.button} key={i}>
              {BuildChildren(item)}
            </div>
          ))}
        </div>}
      </div>
    </div>
  );
};

CardTextC.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Sub heading on the card
  */
  subHeading: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * Content of the card rendered below the contentMarkup
  */
  longContentMarkup: PropTypes.string,
  /**
   * List of buttons
  */
  buttons: PropTypes.array,
  /**
   * Top color of the card
  */
  color: PropTypes.string,
};

export default CardTextC;
